import {
  TeamOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  UsergroupDeleteOutlined
} from "@ant-design/icons";
import { Card, Col, Row, Statistic } from "antd";
import React, { Fragment } from "react";
import { Link } from 'react-router-dom';
import "./style.css";

const NewDashboardCard = ({ information, selectedDates }) => {
  return (
    <Fragment>
      <section className="mt-5 mb-5">
        <div className="site-statistic-demo-card ">
          <Row gutter={[16, 16]} justify={"space-between"}>
            <Col xs={20} sm={16} md={12} lg={4} xl={5}>
              <Link to="/admin/hr/staffs">
                <Card className="ant-shadow txt-color-2" bordered={false}>
                  <Statistic
                    title={<p className="text-lg txt-color-2"> TOTAL USERS </p>}
                    loading={!information}
                    value={information?.totalUsers}
                    valueStyle={{
                      color: "#10b981",
                      fontSize: "18px"
                    }}
                    prefix={
                      <TeamOutlined
                        className="mr-4"
                        style={{ fontSize: "18px" }}
                      />
                    }
                  />
                </Card>
              </Link>
            </Col>
            {/* <Col xs={20} sm={16} md={12} lg={5} xl={5}>
            <Link to="/admin/hr/totalSalary">
              <Card className="ant-shadow txt-color-2" bordered={false}>
                <Statistic
                  title={<p className="text-lg  txt-color-2">TOTAL SALARY</p>}
                  loading={!information}
                  value={information?.totalSalary || 0}
                  precision={2}
                  valueStyle={{
                    color: "#4f46e5",
                    fontSize: "18px"
                  }}
                  prefix={
                    <span className="mr-4" style={{ fontSize: "18px" }}>
                      ₹
                    </span>
                  }
                />
              </Card>
              </Link>
            </Col> */}

            <Col xs={20} sm={16} md={12} lg={5} xl={5}>
            {/* <Link to="/admin/hr/totalAttendance"> */}
            <Link to={`/admin/hr/totalAttendance?startdate=${selectedDates.startdate}&enddate=${selectedDates.enddate}&dashboardStatus=Present`}>
              <Card className="ant-shadow txt-color-2" bordered={false}>
                <Statistic
                  title={
                    <p className="text-lg  txt-color-2"> TODAY PRESENT </p>
                  }
                  loading={!information}
                  value={information?.todayPresent}
                  valueStyle={{
                    color: "#0891b2",
                    fontSize: "18px"
                  }}
                  prefix={
                    <UsergroupAddOutlined
                      className="mr-4"
                      style={{ fontSize: "18px" }}
                    />
                  }
                />
                
              </Card>
              </Link>
            </Col>
            <Col xs={20} sm={16} md={12} lg={5} xl={5}>
            {/* <Link to="/admin/hr/totalAttendance"> */}
            <Link to={`/admin/hr/totalAttendance?startdate=${selectedDates.startdate}&enddate=${selectedDates.enddate}&dashboardStatus=On Leave`}>

              <Card className="ant-shadow txt-color-2" bordered={false}>
                <Statistic
                  title={<p className="text-lg  txt-color-2">TODAY LEAVE</p>}
                  loading={!information}
                  value={information?.todayOnLeave}
                  valueStyle={{
                    color: "#a855f7",
                    fontSize: "18px"
                  }}
                  prefix={
                    <UserSwitchOutlined
                      className="mr-4"
                      style={{ fontSize: "18px" }}
                    />
                  }
                />
              </Card>
              </Link>
            </Col>
            <Col xs={20} sm={16} md={12} lg={4} xl={4}>
            {/* <Link to="/admin/hr/totalAttendance"> */}
            <Link to={`/admin/hr/totalAttendance?startdate=${selectedDates.startdate}&enddate=${selectedDates.enddate}&dashboardStatus=Absent`}>

              <Card className="ant-shadow txt-color-2" bordered={false}>
                <Statistic
                  title={<p className="text-lg  txt-color-2"> ABSENT</p>}
                  loading={!information}
                  value={information?.todayAbsent}
                  valueStyle={{
                    color: "#f43f5e",
                    fontSize: "18px"
                  }}
                  prefix={
                    <UsergroupDeleteOutlined
                      className="mr-4"
                      style={{ fontSize: "18px" }}
                    />
                  }
                />
              </Card>
              </Link>
            </Col>
          </Row>
        </div>
      </section>
    </Fragment>
  );
};

export default NewDashboardCard;
